import styled from '@emotion/styled';
import { numberFormatter } from '@dnhb/formatters';
import PropTypes from 'prop-types';
import { useRef } from 'react';

const lineheightFix = {
  '&::before': {
    content: "''",
    display: 'block',
    height: 0,
    width: 0,
    marginTop: 'calc(-0.325 * 0.5em)',
  },
  '&::after': {
    content: "''",
    display: 'block',
    height: 0,
    width: 0,
    marginBottom: 'calc(-0.2 * 0.5em)',
  },
};

const CurrencyContainer = styled.div(props => ({
  display: 'inline-flex',
  alignItems: 'flex-start',
  fontWeight: props.fontWeight ? props.fontWeight : '600',
}));

const PreFix = styled.span(props => {
  const fontSize = props.fontSize
    ? `${props.fontSize}px`
    : props.styleRef &&
      props.styleRef.current &&
      window.getComputedStyle(props.styleRef.current).getPropertyValue('font-size');
  return {
    color: props.theme.highlightColor,
    fontSize: parseInt(fontSize) <= 18 || props.disableFontSizeLimitOfPrefix ? fontSize : '18px',
    lineHeight: 1,
    ...lineheightFix,
  };
});

const Value = styled.span(props => {
  return {
    color: props.theme.primaryColor,
    fontSize: props.fontSize ? `${parseInt(props.fontSize)}px` : 'inherit',
    marginLeft: '5px',
    lineHeight: 1,
    ...lineheightFix,
  };
});

const Currency = ({ value, decimals, alwaysShowDecimals, ...props }) => {
  const styleRef = useRef();
  return (
    <span ref={styleRef}>
      <CurrencyContainer {...props}>
        <PreFix {...props} styleRef={styleRef}>
          €
        </PreFix>
        <Value {...props}>{numberFormatter(value, decimals, alwaysShowDecimals)}</Value>
      </CurrencyContainer>
    </span>
  );
};

Currency.propTypes = {
  value: PropTypes.number.isRequired,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.string,
  decimals: PropTypes.number,
  alwaysShowDecimals: PropTypes.bool,
  disableFontSizeLimitOfPrefix: PropTypes.bool,
};

Currency.defaultProps = {
  fontSize: '',
  fontWeight: '600',
  decimals: 2,
  alwaysShowDecimals: false,
  disableFontSizeLimitOfPrefix: false,
};

export default Currency;
